import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import {IndexPage} from "./pages/index/IndexPage";
import {Redirect, Route, Switch} from "react-router";
import {AuthStore} from "../stores/AuthStore";
import {lazyInject} from "@intelingu/core/IoC/container";
import {Header} from "./partials/Header";
import {RouteComponentProps} from "react-router-dom";
import {CreateTranslation} from "./pages/creation/lp/CreateTranslation";
import {CreateVocabulary} from "./pages/creation/lp/CreateVocabulary";
import {NextUrl} from "./pages/creation/NextUrl";
import {CreateExercise} from "./pages/creation/lp/CreateExercise";
import {ReviewExercise} from "./pages/creation/lp/ReviewExercise";
import {ReviewVocabulary} from "./pages/creation/lp/ReviewVocabulary";
import {EscalateExercise} from "./pages/creation/lp/EscalateExercise";
import {EscalateVocabulary} from "./pages/creation/lp/EscalateVocabulary";
import {CreateMnemo} from "./pages/creation/mc/CreateMnemo";
import {ReviewMnemo} from "./pages/creation/mc/ReviewMnemo";
import {EscalateMnemo} from "./pages/creation/mc/EscalateMnemo";
import {CreateMedia} from "./pages/creation/me/CreateMedia";
import {ReviewMedia} from "./pages/creation/me/ReviewMedia";
import {EscalateMedia} from "./pages/creation/me/EscalateMedia";
import {StatsOverviewPage} from "./pages/stats/StatsOverviewPage";
import {VocabularyCardsPage} from "./pages/stats/cards/VocabularyCardsPage";
import {LanguagesPage} from "./pages/admin/languages/LanguagesPage";
import {CoursesPage} from "./pages/admin/courses/CoursesPage";
import {TopicOverview} from "./pages/admin/topic/TopicOverview";
import {ExplanationEdit} from "./pages/admin/explanation/ExplanationEdit";
import {CreateCoursePage} from "./pages/admin/courses/CreateCoursePage";
import {LegsPage} from "./pages/admin/legs/LegsPage";
import {UpdateLegPage} from "./pages/admin/legs/UpdateLegPage";
import {RoleListPage} from "./pages/stats/RoleListPage";
import {ReleaseMnemoPage} from "./pages/admin/mnemo/ReleaseMnemoPage";
import {UserStatsPage} from "./pages/admin/stats/UserStatsPage";
import {DashboardsRoute} from "./pages/admin/dashboards/DashboardsRoute";
import {PreviewDashboardRoute} from "./pages/admin/dashboards/PreviewDashboardRoute";
import {CreateTopicPage} from "./pages/admin/topic/CreateTopicPage";
import {UserManagement} from "./pages/admin/users/UserManagement";
import {ContentEditingPage} from "./pages/admin/content/ContentEditingPage";

interface MainLayoutProps extends RouteComponentProps<any> {
}

@observer export class MainLayout extends Component<MainLayoutProps, any> {

    @lazyInject(AuthStore) authStore: AuthStore;

    render() {
        return <div className={'profile-layout admin-layout'}>
            <Header {...this.props} />

            <Switch>
                <Route path={`/creation/next/:courseId/:role`} component={NextUrl} />
                <Route path={`/lp/translation`} component={CreateTranslation} />
                <Route path={`/lp/vocabulary`} component={CreateVocabulary} />
                <Route path={`/lp/exercise`} component={CreateExercise} />
                <Route path={`/lp/review/exercise`} component={ReviewExercise} />
                <Route path={`/lp/review/vocabulary`} component={ReviewVocabulary} />
                <Route path={`/lp/escalate/exercise`} component={EscalateExercise} />
                <Route path={`/lp/escalate/vocabulary`} component={EscalateVocabulary} />
                <Route path={`/edit/translation`} render={props => {
                    return <CreateTranslation editMode={true} />
                }} />
                <Route path={`/edit/vocabulary`} render={props => {
                    return <EscalateVocabulary editMode={true} />
                }} />
                <Route path={`/edit/exercise`} render={props => {
                    return <EscalateExercise editMode={true} />
                }} />
                <Route path={`/mc/update`} component={CreateMnemo} />
                <Route path={`/mc/review`} component={ReviewMnemo} />
                <Route path={`/mc/escalate`} component={EscalateMnemo} />
                <Route path={`/me/create`} component={CreateMedia} />
                <Route path={`/me/review`} component={ReviewMedia} />
                <Route path={`/me/escalate`} component={EscalateMedia} />
                <Route path={`/stats-overview/vocabulary-cards/user/:userId`} component={VocabularyCardsPage} />
                <Route path={`/stats-overview/mnemo-cards/user/:userId`} component={VocabularyCardsPage} />
                <Route path={`/stats-overview/vocabulary-cards`} component={VocabularyCardsPage} />
                <Route path={`/stats-overview/mnemo-cards`} component={VocabularyCardsPage} />
                <Route path={`/stats-overview/roles/:role`} component={RoleListPage} />
                <Route path={`/stats-overview`} component={StatsOverviewPage} />
                <Route path={`/vocabulary-cards`} component={VocabularyCardsPage} />
                <Route path={`/mnemo-cards`} component={VocabularyCardsPage} />
                <Route path={`/release-mnemo`} component={ReleaseMnemoPage} />
                <Route path={`/user-management`} component={UserManagement} />
                <Route path={`/user-stats`} component={UserStatsPage} />
                <Route path={`/dashboards/:role`} component={PreviewDashboardRoute} />
                <Route path={`/dashboards`} component={DashboardsRoute} />
                <Route path={`/languages`} component={LanguagesPage} />
                <Route path={`/courses/:language/topic/:topic/explanations/:id`} component={ExplanationEdit} />
                <Route path={`/courses/:language/topic/:topic`} component={TopicOverview} />
                <Route path={`/courses/:language/stage/:stage/topic`} component={CreateTopicPage} />
                <Route path={`/courses/:language/stage/:stage/legs/:id`} component={UpdateLegPage} />
                <Route path={`/courses/:language/stage/:stage/legs`} component={LegsPage} />
                <Route path={`/courses/create`} component={CreateCoursePage} />
                <Route path={`/courses`} component={CoursesPage} />
                <Route path={`/content-editing`} component={ContentEditingPage} />
                <Route path={`/`} component={IndexPage} />
            </Switch>
        </div>
    }

}
